var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-none p-0 m-0 md:flex md:flex-row text-center md:text-left"},_vm._l((_vm.item.links),function(_item){return _c('sb-render',{key:_item._uid,attrs:{"item":_item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }